import React, { useCallback, useEffect, useMemo, useState } from 'react'
import { API_BASE_URL } from '../../config';
import { useSelector } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import { set } from 'react-hook-form';
import { get } from 'jquery';
import { LogoAdda } from '../../assets';
// Komponen preview struk sesuai gambar
function ReceiptPrintPreview({ orderItems, patients, workers }) {
    // Dummy data, bisa diganti dengan props/data asli
    const user = useSelector(state => state.user);
    // const navigate = useNavigate();
    const location = useLocation();

    const [Klinik, setKlinik] = useState(null);
    const [transaction, setTransaction] = useState(null);
    const [klinikLoading, setKlinikLoading] = useState(false);

    const transactionState = useMemo(() => {
        return location.state?.transaction || {};
    }, [location.state]);
    
    const getKlinik = useCallback(async () => {
        //ambil dari API
        try{
            const token = localStorage.getItem("access_token");
            let url = `${API_BASE_URL}/auth/clinic_get_klinik/${transactionState?.klinik_id}`;
            const response = await fetch(url, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    ...(token && { Authorization: `Bearer ${token}` }),
                }
            });
            if(!response.ok) {
                throw new Error('Network response was not ok');
            }
            const data = await response.json();
            if(data.code === 200){
                setKlinik(data.data);
            }else{
                console.log(data.message);
            }
        }catch(err){
            console.log(err);
        }
    }, [transactionState]);

    const getTransaction = useCallback(async () => {
        //ambil dari API
        try{
            const token = localStorage.getItem("access_token");
            let url = `${API_BASE_URL}/auth/patient_transaction/detail/${transactionState?.klinik_id}/${transactionState?.no_transaction}/${patients?.patient?.no_medical_record}`;
            const response = await fetch(url, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    ...(token && { Authorization: `Bearer ${token}` }),
                }
            });
            if(!response.ok) {
                throw new Error('Network response was not ok');
            }
            const data = await response.json();
            if(data.code === 200){
                setTransaction(data.data);
            }else{
                console.log(data.message);
            }
        }catch(err){
            console.log(err);
        }
    }, [patients, transactionState]);

    useEffect(() => {
        setKlinikLoading(true);
        Promise.all([
            getKlinik(),
            getTransaction()
        ]).finally(() => {
            setKlinikLoading(false);
        });
    }, [getKlinik, getTransaction]);

    const formatDatelocal = (dateString) => {
        const options = { year: 'numeric', month: 'short', day: '2-digit' };
        const date = new Date(dateString);
        return date.toLocaleDateString('id-ID', options);
    }

    const clinic = {
        name: Klinik ? Klinik.clinic_name : 'KHL Klinik Hang Lekiu',
        address: Klinik ? Klinik.address : 'Jl. Hang Lekiu III No. 10, RT.7/RW.4, Gunung, Kec. Kby. Baru, Kota Jakarta Selatan, Daerah Khusus Ibukota Jakarta 12120',
        logo: Klinik ? Klinik.klinik_detail?.logo : LogoAdda,
        phone: Klinik ? Klinik.klinik_detail?.phone : '021-12345678',
        email: Klinik ? Klinik.klinik_detail?.email : 'info@khlklinik.com',
        youtube: Klinik ? Klinik.klinik_detail?.youtube : 'KHLKlinikHangLekiu',
        facebook: Klinik ? Klinik.klinik_detail?.facebook : 'KHLKlinikHangLekiu',
        instagram: Klinik ? Klinik.klinik_detail?.instagram : 'KHLKlinikHangLekiu',
        twitter: Klinik ? Klinik.klinik_detail?.twitter : 'KHLKlinikHangLekiu',
        website: Klinik ? Klinik.klinik_detail?.website : 'www.khlklinikhanglekiu.com',
        whatsapp: Klinik ? Klinik?.klinik_detail?.whatsapp : '081234567890',
    };
    const receipt = {
        number: transaction ? transaction?.transaction?.no_transaction : 'RCP-0002',
        date: transaction ? transaction?.transaction?.created_at : '02 Jan 2023',
        medicalRecord: transaction ? transaction?.transaction?.no_medical_record : '000021',
        patient: transaction ? patients?.patient?.full_name : 'Yuliana Syahputri',
        collectedBy: transaction ? transaction?.transaction?.created_by_name : 'Maryanah Ulfa',
    };
   
    const items = transaction?.transaction?.details?.length >= 1 ? transaction?.transaction?.details : [
        { name: 'Cosmetic Acupuncture (10x)', worker: 'dr. Siska Kristiani / Nurul Husein 4/10', qty: 1, price: 5600000, disc: 0, amount: 5600000 },
        { name: 'Bars 30 Menit', worker: 'dr. Yuni Yositha', qty: 1, price: 400000, disc: 10, amount: 360000 },
        { name: 'Night Cream', worker: '', qty: 1, price: 125000, disc: 0, amount: 125000 },
    ];
    const subtotal = items.reduce((a, b) => a + Number(b.unit_price) * Number(b.qty), 0);
    const discTotal = items.reduce((a, b) => a + ( ( Number(b.unit_price) * Number(b.qty) ) - Number(b.final_price) ), 0);
    const total = items.reduce((a, b) => a + Number(b.final_price), 0);
    const totalPaid = Number(transaction?.transaction?.total_paid) || 0;
    return (
        <>
        {klinikLoading ? (
            <div className="d-flex justify-content-center align-items-center" style={{ minHeight: 200 }}>
                <div className="spinner-border text-primary" role="status">
                <span className="visually-hidden">Loading...</span>
                </div>
            </div>
        ) : (
            <div className='receipt-print-area' style={{ maxWidth: 500, margin: '0 auto', background: '#fff', padding: 32, borderRadius: 12, boxShadow: '0 0 8px #eee' }}>
                <div style={{ textAlign: 'center', marginBottom: 16 }}>
                    <img src={clinic.logo} alt='logo' style={{ height: 48, marginBottom: 8 }} />
                    <h4 style={{ fontWeight: 700, marginBottom: 4 }}>{clinic.name}</h4>
                    <div style={{ fontSize: 13, color: '#555', marginBottom: 8 }}>{clinic.address}</div>
                    <hr />
                </div>
                <div style={{ fontSize: 13, marginBottom: 8 }}>
                    <div style={{ float: 'left', textAlign: 'left' }}>
                        Receipt Number: <b>{receipt.number}</b><br />
                        Date Transaction: {formatDatelocal(receipt.date)}<br />
                        Medical Record: {receipt.medicalRecord}<br />
                        Patient Name: {receipt.patient}<br />
                        Collected By: {receipt.collectedBy}
                    </div>
                    <div style={{ clear: 'both' }}></div>
                </div>
                <table style={{ width: '100%', fontSize: 13, marginBottom: 12, borderCollapse: 'collapse' }}>
                    <thead>
                        <tr style={{ background: '#f8f9fa' }}>
                            <th style={{ textAlign: 'left', padding: 6 }}>Treatment/Product</th>
                            <th style={{ textAlign: 'center', padding: 6 }}>Qty</th>
                            <th style={{ textAlign: 'right', padding: 6 }}>Price</th>
                            <th style={{ textAlign: 'right', padding: 6 }}>Disc</th>
                            <th style={{ textAlign: 'right', padding: 6 }}>Amount</th>
                        </tr>
                    </thead>
                    <tbody>
                        {items.map((item, idx) => (
                            <tr key={idx}>
                                <td style={{ padding: 6 }}>
                                    {item.reference_type === 'treatment' ? item.treatment.treatment_name :
                                     item.reference_type === 'product' ? item.product.name :
                                     item.reference_type === 'medicine' ? item.product.name :
                                     item.name}
                                    {item.doctor && <div style={{ fontSize: 11, color: '#888' }}>({item.doctor.full_name}/{item.therapist.full_name})</div>}
                                </td>
                                <td style={{ textAlign: 'center', padding: 6 }}>{item.qty}</td>
                                <td style={{ textAlign: 'right', padding: 6 }}>{Number(item.total_price).toLocaleString('id-ID')}</td>
                                <td style={{ textAlign: 'right', padding: 6 }}>{item.discount_value ? item.discount_value + '%' : '0.00'}</td>
                                <td style={{ textAlign: 'right', padding: 6 }}>{Number(item.final_price).toLocaleString('id-ID')}</td>
                            </tr>
                        ))}
                    </tbody>
                </table>
                <div style={{ fontSize: 13, marginBottom: 8 }}>
                    <div style={{ float: 'right', textAlign: 'right' }}>
                        <table style={{ fontSize: 13 }}>
                            <tbody>
                                <tr><td>Sub total:</td><td style={{ textAlign: 'right', paddingLeft: 12 }}>Rp. {subtotal.toLocaleString('id-ID')}</td></tr>
                                <tr><td>Disc:</td><td style={{ textAlign: 'right', paddingLeft: 12 }}>Rp. {discTotal.toLocaleString('id-ID')}</td></tr>
                                <tr><td>Total:</td><td style={{ textAlign: 'right', paddingLeft: 12 }}>Rp. {total.toLocaleString('id-ID')}</td></tr>
                                <tr><td>Total Paid:</td><td style={{ textAlign: 'right', paddingLeft: 12 }}>Rp. {totalPaid.toLocaleString('id-ID')}</td></tr>
                                {
                                    transaction?.payments ? transaction?.payments?.map((pay, index) => (
                                        <tr key={index}>
                                            <td>{pay.payment_method} :</td>
                                            <td style={{ textAlign: 'right', paddingLeft: 12, fontWeight: 700 }}>Rp. {Number(pay.amount).toLocaleString('id-ID')}</td>
                                        </tr>
                                    )) : <tr></tr>
                                }
                                {/* <tr><td>Cash:</td><td style={{ textAlign: 'right', paddingLeft: 12 }}>Rp. {cash.toLocaleString('id-ID')}</td></tr> */}
                                {/* <tr><td>Deposit :</td><td style={{ textAlign: 'right', paddingLeft: 12, fontWeight: 700 }}>Rp. {deposit.toLocaleString('id-ID')}</td></tr> */}
                            </tbody>
                        </table>
                    </div>
                    <div style={{ clear: 'both' }}></div>
                </div>
                <div style={{ fontSize: 12, marginTop: 16, borderTop: '1px solid #eee', paddingTop: 8 }}>
                    <b>CONTACT INFORMATIONS</b><br />
                    {clinic.name}<br />
                    Instagram, Website, Facebook<br />
                    {clinic.instagram}<br />
                    {clinic.website}<br />
                    {clinic.facebook}<br />
                    Please use as {receipt.number} as a reference number<br />
                    For any questions please contact us at Whatsapp
                </div>
            </div>
        )
        }
        
        </>
    );
}

export default ReceiptPrintPreview;

// Cara penggunaan:
// <ReceiptPrintPreview orderItems={orderItems} patients={patients} workers={workers} />